import { render, staticRenderFns } from "./InstructionalTooltip.vue?vue&type=template&id=9a1b994c"
import script from "./InstructionalTooltip.vue?vue&type=script&lang=js"
export * from "./InstructionalTooltip.vue?vue&type=script&lang=js"
import style0 from "./InstructionalTooltip.vue?vue&type=style&index=0&id=9a1b994c&prod&module=true&lang=css"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports